import React from 'react';
import cx from 'classnames';

import TextIconGroup from '../../molecules/TextIconGroup';

import styles from './TextIconGroupList.module.scss';
import usePresenter from './TextIconGroupList.presenter';
import getProps from './TextIconGroupList.props';
import { TextIconGroupListCombinedProps } from './types';


const TextIconGroupList: React.FC<TextIconGroupListCombinedProps> = (props) => {
  const {
    className,
    classes,
    textIconGroups,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.textIconGroupList;

  const textIconGroupViews = textIconGroups?.map((textIconGroup, index) => (
    <TextIconGroup
      key={index}
      className={cx(styles.textIconGroup, classes?.textIconGroup)}
      {...internalProps.textIconGroup}
      {...textIconGroup} />
  )) || [];

  return (
    <div className={cx(currentStyle, className)}>
      {textIconGroupViews}
    </div>
  );
};

export default TextIconGroupList;

